/**
 * mSTEM Robot Manager row-action cell. Renders Edit + Delete icon buttons
 * for a single robot row. Class component with bindAll so per-row handlers
 * satisfy react/jsx-no-bind without inline arrow allocations.
 */
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './robot-manager-modal.css';

class RobotActionsCell extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, ['handleEdit', 'handleDelete', 'handleConnect']);
    }
    handleEdit (e) {
        if (e && e.stopPropagation) e.stopPropagation();
        this.props.onEdit(this.props.row);
    }
    handleDelete (e) {
        if (e && e.stopPropagation) e.stopPropagation();
        this.props.onDelete(this.props.row.id);
    }
    handleConnect (e) {
        if (e && e.stopPropagation) e.stopPropagation();
        this.props.onConnect(this.props.row);
    }
    render () {
        const {editLabel, deleteLabel, connectLabel} = this.props;
        return (
            <div className={styles.actionsCell}>
                <button
                    className={styles.iconBtn}
                    title={connectLabel}
                    type="button"
                    onClick={this.handleConnect}
                >
                    {'🔗'}
                </button>
                <button
                    className={styles.iconBtn}
                    title={editLabel}
                    type="button"
                    onClick={this.handleEdit}
                >
                    {'✎'}
                </button>
                <button
                    className={styles.iconBtnDanger}
                    title={deleteLabel}
                    type="button"
                    onClick={this.handleDelete}
                >
                    {'×'}
                </button>
            </div>
        );
    }
}

RobotActionsCell.propTypes = {
    connectLabel: PropTypes.string.isRequired,
    deleteLabel: PropTypes.string.isRequired,
    editLabel: PropTypes.string.isRequired,
    onConnect: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    row: PropTypes.shape({id: PropTypes.string.isRequired}).isRequired
};

export default RobotActionsCell;
